/**
 * HydraulicSeparation — animated SVG showing primary/secondary loops
 * with a low-loss header creating a hydraulic neutral point.
 */

export function HydraulicSeparation() {
  return (
    <figure style={{ margin: 0 }}>
      <svg viewBox="0 0 480 240" width="100%" role="img" aria-label="Hydraulic separation with low-loss header">
        <title>Primary and secondary loops separated by a low-loss header</title>
        <defs>
          <style>{`
            .hs-pipe { stroke: #64748b; stroke-width: 2.5; fill: none; }
            .hs-flow-hot { stroke: #ef4444; stroke-width: 2; fill: none; opacity: 0.6; stroke-dasharray: 8,5; animation: hs-flow 1s linear infinite; }
            .hs-flow-cool { stroke: #3b82f6; stroke-width: 2; fill: none; opacity: 0.6; stroke-dasharray: 8,5; animation: hs-flow 1s linear infinite; }
            .hs-llh { fill: #f1f5f9; stroke: #475569; stroke-width: 2; }
            .hs-label { font-family: system-ui, sans-serif; font-size: 11px; fill: #475569; text-anchor: middle; }
            .hs-heading { font-family: system-ui, sans-serif; font-size: 12px; fill: #1e293b; font-weight: 600; text-anchor: middle; }
            .hs-pump { fill: #dbeafe; stroke: #3b82f6; stroke-width: 1.5; }
            @keyframes hs-flow { to { stroke-dashoffset: -13; } }
          `}</style>
        </defs>

        {/* Primary loop label */}
        <text x="120" y="20" className="hs-heading">Primary loop</text>

        {/* Boiler */}
        <rect x="40" y="60" width="80" height="40" rx="6" fill="#fef3c7" stroke="#f59e0b" strokeWidth="2" />
        <text x="80" y="85" className="hs-label">Boiler</text>

        {/* Primary pump */}
        <circle cx="80" cy="140" r="12" className="hs-pump" />
        <text x="80" y="144" className="hs-label" style={{ fontSize: '9px' }}>P1</text>

        {/* Primary piping — flow (hot, top) */}
        <path d="M 120 75 L 200 75" className="hs-pipe" />
        <path d="M 120 75 L 200 75" className="hs-flow-hot" />

        {/* Primary piping — return (cool, bottom) */}
        <path d="M 200 165 L 120 165 L 120 100 L 80 100" className="hs-pipe" />
        <path d="M 200 165 L 120 165 L 120 140" className="hs-flow-cool" />

        {/* Primary down to pump */}
        <line x1="80" y1="100" x2="80" y2="128" className="hs-pipe" />

        {/* LLH (Low-Loss Header) */}
        <rect x="200" y="50" width="40" height="140" rx="8" className="hs-llh" />
        <text x="220" y="125" className="hs-label" style={{ fontSize: '10px', writingMode: 'vertical-rl' } as any}>
          LLH
        </text>

        {/* Neutral point indicator */}
        <circle cx="220" cy="120" r="4" fill="#10b981" />

        {/* Secondary loop label */}
        <text x="360" y="20" className="hs-heading">Secondary loop</text>

        {/* Secondary piping — flow (hot, top) */}
        <path d="M 240 75 L 320 75" className="hs-pipe" />
        <path d="M 240 75 L 320 75" className="hs-flow-hot" />

        {/* Secondary piping — return (cool, bottom) */}
        <path d="M 320 165 L 240 165" className="hs-pipe" />
        <path d="M 320 165 L 240 165" className="hs-flow-cool" />

        {/* Secondary pump */}
        <circle cx="360" cy="140" r="12" className="hs-pump" />
        <text x="360" y="144" className="hs-label" style={{ fontSize: '9px' }}>P2</text>

        {/* Radiators */}
        <rect x="340" y="60" width="80" height="40" rx="6" fill="#fce7f3" stroke="#ec4899" strokeWidth="1.5" />
        <text x="380" y="85" className="hs-label">Emitters</text>

        {/* Secondary circuit down */}
        <line x1="320" y1="75" x2="340" y2="75" className="hs-pipe" />
        <line x1="380" y1="100" x2="380" y2="128" className="hs-pipe" />
        <line x1="380" y1="152" x2="380" y2="165" className="hs-pipe" />
        <line x1="380" y1="165" x2="320" y2="165" className="hs-pipe" />

        {/* Labels */}
        <text x="220" y="210" className="hs-label" style={{ fill: '#059669' }}>
          Hydraulic neutral point
        </text>
        <text x="220" y="225" className="hs-label" style={{ fontSize: '10px' }}>
          Pumps don't interfere with each other
        </text>
      </svg>
    </figure>
  );
}
